import React from "react";
import PropTypes from "prop-types";

import Linkify from "react-linkify";
import { useTranslation } from "react-i18next";

import Title from "../../atoms/Title";

import {
  StyledAddSpecialPackToShoppingCartButton,
  InfoBoxItemProductImage,
  InfoBoxItemDescriptionHolderHead,
  InfoBoxItemDescriptionHolderHeadTitle,
} from "../../atoms/SpecialInfoBoxItem";
import RegisterSpecialPackInterestButton from "../../atoms/RegisterSpecialPackInterestButton";
import { I18N_NAMESPACES } from "../../../helpers/constants";

import arrowBack from "../../../assets/images/icons/arrow-left-straight.svg";
import {
  StyledInfoBoxItem,
  StyledInfoBoxItemProductHolderButtons,
  StyledInfoBoxItemDescriptionHolder,
  StyledInfoBoxItemProductHolder,
  InfoBoxItemDescriptionWrapper,
  StyledDescription,
  CloseTrayButton,
  MainTitle,
  StyledContentLink,
} from "./style";

const linkifyComponentDecorator = (href, text, key) => (
  <StyledContentLink href={href} key={key} target="_blank" rel="noopener noreferrer">
    {text}
  </StyledContentLink>
);

const SpecialBoxInfo = ({
  specialPackEdition,
  specialPackEdition: {
    isAvailable,
    name,
    heroTopImageLargeUrl,
    heroTopTitle,
    heroTopSubTitle,
    section1Title,
    section1Text,
    section2Title,
    section2Text,
    section3Title,
    section3Text,
  },
  handleToggleDetailsTray = () => {},
  toggleAddSpecialPackTray,
  selectSpecialPack = null,
  infoBoxItemStyle = [],
  infoBoxItemProductHolderButtonsStyle = [],
  infoBoxItemProductButtonsStyle = [],
  infoBoxItemDescriptionHolderStyle = [],
  infoBoxItemProductHolderStyle = [],
  infoBoxItemDescriptionWrapperStyle = [],
}) => {
  const { t } = useTranslation(I18N_NAMESPACES.SPECIAL_PACKS);

  return (
    <>
      <StyledInfoBoxItem css={infoBoxItemStyle}>
        <CloseTrayButton onClick={handleToggleDetailsTray}>
          <img src={arrowBack} alt="Close button" />
        </CloseTrayButton>
        <StyledInfoBoxItemProductHolder css={infoBoxItemProductHolderStyle}>
          <InfoBoxItemProductImage src={heroTopImageLargeUrl} alt={name} />
          <StyledInfoBoxItemProductHolderButtons css={infoBoxItemProductHolderButtonsStyle}>
            {isAvailable ? (
              <StyledAddSpecialPackToShoppingCartButton
                ghost
                css={infoBoxItemProductButtonsStyle}
                onClick={() => {
                  toggleAddSpecialPackTray();
                  selectSpecialPack && selectSpecialPack(specialPackEdition);
                }}
              >
                {t("specialPacks:choose")}
              </StyledAddSpecialPackToShoppingCartButton>
            ) : (
              <RegisterSpecialPackInterestButton specialPackEdition={specialPackEdition} full />
            )}
          </StyledInfoBoxItemProductHolderButtons>
        </StyledInfoBoxItemProductHolder>

        <InfoBoxItemDescriptionWrapper css={infoBoxItemDescriptionWrapperStyle}>
          <StyledInfoBoxItemDescriptionHolder css={infoBoxItemDescriptionHolderStyle}>
            <InfoBoxItemDescriptionHolderHead>
              <InfoBoxItemDescriptionHolderHeadTitle>{heroTopSubTitle}</InfoBoxItemDescriptionHolderHeadTitle>
            </InfoBoxItemDescriptionHolderHead>

            <MainTitle tag={2} fontSecondary mb>
              {heroTopTitle}
            </MainTitle>

            <Title tag={5} mbSmall uppercase tightLineHeight>
              {section1Title}
            </Title>

            <StyledDescription>
              <Linkify componentDecorator={linkifyComponentDecorator}>{section1Text}</Linkify>
            </StyledDescription>

            <Title tag={5} mbSmall uppercase tightLineHeight>
              {section2Title}
            </Title>

            <StyledDescription>
              <Linkify componentDecorator={linkifyComponentDecorator}>{section2Text}</Linkify>
            </StyledDescription>

            <Title tag={5} mbSmall uppercase tightLineHeight>
              {section3Title}
            </Title>

            <StyledDescription>
              <Linkify componentDecorator={linkifyComponentDecorator}>{section3Text}</Linkify>
            </StyledDescription>
          </StyledInfoBoxItemDescriptionHolder>
        </InfoBoxItemDescriptionWrapper>
      </StyledInfoBoxItem>
    </>
  );
};

SpecialBoxInfo.propTypes = {
  specialPackEdition: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    heroTopTitle: PropTypes.string.isRequired,
    heroTopSubTitle: PropTypes.string.isRequired,
    section1Text: PropTypes.string.isRequired,
    specialpackoptionSet: PropTypes.arrayOf(
      PropTypes.shape({
        product: PropTypes.shape({
          sellingPrice: PropTypes.number.isRequired,
        }).isRequired,
      })
    ).isRequired,
  }).isRequired,
  handleToggleDetailsTray: PropTypes.func,
  toggleAddSpecialPackTray: PropTypes.func.isRequired,
  selectSpecialPack: PropTypes.func,
  infoBoxItemStyle: PropTypes.arrayOf(PropTypes.string),
  infoBoxItemDescriptionHolderStyle: PropTypes.arrayOf(PropTypes.string),
  infoBoxItemProductHolderButtonsStyle: PropTypes.arrayOf(PropTypes.string),
  infoBoxItemProductButtonsStyle: PropTypes.arrayOf(PropTypes.string),
  infoBoxItemProductHolderStyle: PropTypes.arrayOf(PropTypes.string),
  infoBoxItemDescriptionWrapperStyle: PropTypes.arrayOf(PropTypes.string),
};

export default SpecialBoxInfo;
